/**
 * Determines if a string is a hyperlink.
 *
 * @example
 * isHyperLink('https://www.google.com') // true
 * isHyperLink('www.google.com') // true
 * isHyperLink('google.com') // true
 * isHyperLink('google') // false
 * isHyperLink('account@email.com') // false
 */
const isHyperLink = (value: string) => {
  // Taken from https://stackoverflow.com/questions/6038061/regular-expression-to-find-urls-within-a-string
  // Slightly modified to make the protocol part optional and allows parens to be in the URL.
  // Modified per BMAPS-1317 to make the TLD matching more strict. This prevents decimal numbers like '10.5'
  // from being matched, but does prevent some valid, albeit very rare, URLs from being matched.
  const urlRegExp = new RegExp(/((http|ftp|https):\/\/)?([\w-]+(?:(?:\.[a-zA-z_-]+)+))([\w.,@?()^=%&:/~+#-]*[\w@?()^=%&/~+#-])/);
  const match = urlRegExp.exec(value);

  // A valid hyperlink will not contain an @ or a space
  return (match?.length && (!value.includes('@') && !value.includes(' '))) || false;
};

export {
  isHyperLink,
};
